import React, { useContext} from "react";
import profilePic from 'assets/img/descarga.png'; // Tell Webpack this JS file uses this image
// components
import { UserContext } from "UserContext";

export default function CardProfile() {

  // User Profile
  const contextStore = useContext(UserContext);
  const userProfile = contextStore.userProfile;

  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-xl rounded-lg my-12">
        <div className="px-6">
          <div className="flex flex-wrap justify-center">
            <div className="w-full px-4 flex justify-center">
              <div className="relative">
                <img
                  alt="profile pic"
                  src={profilePic}
                  className="shadow-xl rounded-full h-auto align-middle border-none absolute -m-16 -ml-20 lg:-ml-16 max-w-150-px"
                />
              </div>
            </div>
            <div className="w-full px-4 text-center mt-20">
              <div className="flex justify-center py-4 lg:pt-4 pt-8">
                <div className="mr-4 p-3 text-center">
                  <span className="text-xl font-bold block uppercase tracking-wide text-gray-700">
                    22
                  </span>
                  <span className="text-sm text-gray-500">Contactos</span>
                </div>
                <div className="mr-4 p-3 text-center">
                  <span className="text-xl font-bold block uppercase tracking-wide text-gray-700">
                    10
                  </span>
                  <span className="text-sm text-gray-500">Productos</span>
                </div>
                <div className="lg:mr-4 p-3 text-center">
                  <span className="text-xl font-bold block uppercase tracking-wide text-gray-700">
                    89
                  </span>
                  <span className="text-sm text-gray-500">Encargos</span>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center mt-8">
            <h3 className="text-xl font-semibold leading-normal text-gray-800 mb-2">
              {userProfile.nombre}
            </h3>
            <div className="text-sm leading-normal mb-2 text-gray-500 font-bold uppercase mt-8">
              <i className="fas fa-map-marker-alt mr-2 text-lg text-gray-500"></i>{" "}
                {userProfile.departamento}, Guatemala
            </div>
            <div className="mb-2 text-gray-700 mt-5">            
              <i className="fas fa-map-marked mr-2 text-lg text-gray-500"></i>
                {userProfile.direccion}
            </div>
            <div className="mb-2 text-gray-700 mt-5">
              <i className="fas fa-briefcase mr-2 text-lg text-gray-500"></i>
                {userProfile.ocupacion}
            </div>
          </div>
          <div className="mt-10 py-10 border-t border-gray-300 text-center">
            <div className="flex flex-wrap justify-center">
              <div className="w-full lg:w-9/12 px-4">
                <p className="mb-4 text-lg leading-relaxed text-gray-800">
                  {/* Control de producto */}
                </p>
                {/* <a
                  href=" "
                  className="font-normal text-blue-500"
                  onClick={(e) => e.preventDefault()}
                >
                  Saber más..
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
